import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export function formatDatePipe(date: string) {
    const m = dayjs(date);
    if (m.isValid()) {
        return m.format("DD/MM/YYYY");
    }
    return "";
}

export function formatDateTimePipe(date: string) {
    const m = dayjs(date);
    if (m.isValid()) {
        return m.format("DD/MM/YYYY-HH:mm:ss");
    }
    return "";
}

// Server trả datetime ở dạng UTC nhưng không có hậu tố "Z" (vd: "2026-07-02T17:00:00"),
// nên phải parse bằng dayjs.utc rồi chuyển về múi giờ của client trước khi hiển thị.
export function formatUtcDateTimePipe(date: string) {
    const m = dayjs.utc(date);
    if (m.isValid()) {
        return m.local().format("DD/MM/YYYY-HH:mm:ss");
    }
    return "";
}